import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import { Icon, Table } from 'antd';
import './Personalization.less';
import './PersonalizationAppIndex.less';
import { INDEX_CONFIG_KEY } from '../../utils/constants';

class PersonalizationAppIndex extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  changeState(record) {
    const { dispatch } = this.props;
    dispatch({
      type: 'appIndex/updateState',
      payload: { id: record.id, state: record.state === 0 ? 1 : 0 }
    });
  }

  getName(confKey) {
    const { intl } = this.props;
    if (confKey == INDEX_CONFIG_KEY.BOOK_KEY) {
      return intl.formatMessage({ id: 'app_index_book' });
    } else if (confKey == INDEX_CONFIG_KEY.ABOUT_KEY) {
      return intl.formatMessage({ id: 'app_index_about' });
    } else if (confKey == INDEX_CONFIG_KEY.VIDEO_MEETING_KEY) {
      return intl.formatMessage({ id: 'app_index_video_meeting' });
    } else if (confKey == INDEX_CONFIG_KEY.MY_MEETING_KEY) {
      return intl.formatMessage({ id: 'app_index_my_meeting' });
    } else if (confKey == INDEX_CONFIG_KEY.INITIATE_KEY) {
      return intl.formatMessage({ id: 'app_index_initiate' });
    } else if (confKey == INDEX_CONFIG_KEY.WEBEX_MEETING_KEY) {
      return intl.formatMessage({ id: 'app_index_webex_meeting' });
    }
  }

  render() {
    const { data = [], intl } = this.props;
    const columns = [
      {
        title: intl.formatMessage({ id: 'app_index_conf_name' }),
        key: 'remark',
        className: 'first-col',
        render: record => {
          const { confKey } = record;
          let name = this.getName(confKey);
          if (record.state === 0) {
            return (
              <div style={{ display: 'flex' }}>
                <div style={{ width: '25px' }}>
                  <Icon
                    type="home"
                    theme="filled"
                    style={{ color: 'blue', fontSize: '15px' }}
                  />
                </div>
                <span style={{ marginLeft: '5px' }}>{name}</span>
              </div>
            );
          } else {
            return (
              <div style={{ display: 'flex' }}>
                <div style={{ width: '25px' }} />
                <span style={{ marginLeft: '5px' }}>{name}</span>
              </div>
            );
          }
        }
      },
      {
        title: intl.formatMessage({ id: 'room_manage_list_oprate' }),
        key: 'operate',
        width: '15%',
        render: record => {
          if (record.state === 0) {
            return (
              <div
                onClick={() => {
                  this.changeState(record);
                }}
                className="btn_cancel_show"
              >
                {intl.formatMessage({ id: 'app_index_conf_cancel_show' })}
              </div>
            );
          } else {
            return (
              <div
                onClick={() => {
                  this.changeState(record);
                }}
                className="btn_set_show"
              >
                {intl.formatMessage({ id: 'app_index_conf_set_show' })}
              </div>
            );
          }
        }
      }
    ];

    return (
      <div className="app_index_conf">
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey={r => r.id}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { appIndex, i18n } = state;
  appIndex.i18n = i18n;
  return { ...appIndex };
};

export default connect(mapStateToProps)(injectIntl(PersonalizationAppIndex));



// WEBPACK FOOTER //
// ./src/routes/Personalization/PersonalizationAppIndex.js